<template>
  <ViewCustomData entityName="news" serviceName="BaseService" :columns="columns" :toolbarFilters="toolbarFilters"
    entitySpec="data_history" scheme="news" :visibleButtons="visibleButtons" ref="viewNewsHistoryData"
    :drawRow="rowClass" />
</template>

<script setup>
import { ref } from 'vue';

const viewNewsHistoryData = ref(null);

const visibleButtons = {
  insert: false,
  edit: false,
  delete: false,
};

const toolbarFilters = [
  {
    name: 'periods',
    enabled: true,
    required: true,
    attrList: { showTime: true, date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
    default: 'За год',
  },
];

const columns = [
  {
    header: 'ID',
    field: 'news_id',
    sortable: true,
    bodyStyle: 'text-align: right; width:65px;',
    filterData: {
      type: 'InputText',
      attrList: { type: 'number', step: '1' },
      placeholder: '...',
    },
  },
  {
    header: 'Важность',
    field: 'news_severity_name',
    sortable: true,
    filterData: {
      options: 'news_severity',
      type: 'MultiSelect',
      mode: 'in',
      'max-width': '250px',
    },
  },
  {
    header: 'Заголовок',
    field: 'news_title',
    sortable: true,
    filterData: {
      type: 'InputText',
    },
  },
  {
    header: 'Содержание',
    field: 'news_desc',
    dataType: 'html',
  },
  {
    header: 'Дата публикации',
    field: 'date_begin',
    sortable: true,
    dataType: 'date-gmt',
    conversion: true,
    headerStyle: 'width: 140px',
    filterData: {
      type: 'Calendar',
      mode: 'dateIsGMT',
      attrList: { dateFormat: 'dd.mm.yy' },
    },
  },
  {
    header: 'Дата прочтения',
    field: 'disable_date',
    sortable: true,
    dataType: 'date-gmt',
    conversion: true,
    headerStyle: 'width: 140px',
    filterData: {
      type: 'Calendar',
      mode: 'dateIsGMT',
      attrList: { dateFormat: 'dd.mm.yy' },
    },
  },
];


const rowClass = (row) => {
  switch (row.news_severity_sysname) {
    case 'INFO':
      return 'row-accessories-green';
    case 'WARN':
      return 'row-accessories-orange';
    case 'HIGH':
      return 'row-accessories-red';
    default:
      return '';
  }
}
</script>